import masterDataSlice from './master-data-reducer'

export {
  fetchMasterData,
  selectHasError,
  selectMasterData
} from './master-data-reducer'

export default masterDataSlice
